import asdfgh from 'asdfgh'
import { PASSWORD_VALIDATOR } from 'utils'

const passwordStrength = {
  DEFAULT: 'negative',
  WEAK: 'attention',
  REGULAR: 'positive',
}

interface IPasswordStrength {
  text?: string
  variant?: string
}

const ValidatePasswordStrength = async (password: string) => {
  const strength: IPasswordStrength = {
    text: undefined,
    variant: undefined,
  }

  if (!password.match(PASSWORD_VALIDATOR)) {
    return strength
  }

  try {
    const result = await asdfgh(password)

    if (result.score === 1) {
      strength.text =
        'Senha fraca. Combine letras e números para fortalecê-la. (Mínimo de 8 caracteres).'
      strength.variant = passwordStrength.WEAK
    } else if (result.score >= 2) {
      strength.text = 'Senha segura'
      strength.variant = passwordStrength.REGULAR
    } else {
      strength.text = 'Senha muito fraca. Combine letras e números (Mínimo de 8 caracteres).'
      strength.variant = passwordStrength.DEFAULT
    }

    return strength
  } catch (err) {
    return strength
  }
}

export { ValidatePasswordStrength }
